import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseChildDialog } from '../../shared/dialogs/base-child-dialog';
import { FertilizationRecommendationSummaryComponent } from '../../events/table/fertilization-hover-panel/recommendation-summary';
import { FertilizationEventService } from '../service';
import { SharedUpdateService } from '../../shared/dialogs/update.service';
import { IFertilizationEvent } from '../interfaces';

export interface FertRecSummaryDialogForm {
	nInWater: number,
	plantingId: number,
	form: FormGroup,
}

@Component({
	moduleId: module.id,
	selector: 'fertilization-recommendation-summary-dialog',
	templateUrl: 'recommendation-summary-dialog.html',
	styleUrls: []
})

export class FertilizationRecommendationSummaryDialog extends BaseChildDialog implements OnInit, OnDestroy {
	@ViewChild(FertilizationRecommendationSummaryComponent, { static: false })
		private recommendationSummary: FertilizationRecommendationSummaryComponent;

	protected _subscriptions$: Subject<boolean>;
	public nInWater: number;
	private _plantingId: number;
	private _form: FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: FertRecSummaryDialogForm,
		private dialogRef: MatDialogRef<FertilizationRecommendationSummaryDialog>,
		private _fertilizationEventService: FertilizationEventService,
		private sharedUpdateService: SharedUpdateService,
	) {
		super(dialogRef, sharedUpdateService);
		this._form = data.form;
		this.nInWater = data.nInWater;
		this._plantingId = data.plantingId;
	}

	ngOnInit(): void {
		super.ngOnInit();
		this._showRecommendationSummary();
	}

	private _showRecommendationSummary(): void {
		this._fertilizationEventService.getRecommendationSummary(this._plantingId,
			this._form.value as IFertilizationEvent)
			.then(res => {

			if (!this.recommendationSummary) {
				return;
			}

			this.recommendationSummary.render(res);
		})
	}
}
